export const formatClientName = (name: string): string => {
  if (!name) return '';
  return name
    .trim()
    .replace(/\s+/g, ' ') // Replaces multiple spaces with a single space
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Cleans a phone number by keeping only digits and adding a prefix if missing.
 * Adjust the default prefix based on your target region (e.g., Venezuela +58).
 */
export const formatPhoneNumber = (
  phone: string,
  defaultPrefix = '+58',
): string => {
  if (!phone) return '';

  // 1. Remove all non-numeric characters except '+'
  let cleaned = phone.replace(/[^\d+]/g, '');

  // 2. If it already starts with '+', keep it.
  if (cleaned.startsWith('+')) {
    return cleaned;
  }

  // 3. For Venezuela specifically (e.g., "04121234567" -> "+584121234567")
  if (cleaned.startsWith('0')) {
    cleaned = cleaned.substring(1);
  }

  return `${defaultPrefix}${cleaned}`;
};
